/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface FlightBookingProjectionRequest
 */
export interface FlightBookingProjectionRequest {
  /**
   * Persisted booking mode. Omission preserves legacy or previously known mode; an explicit mode cannot change.
   * @type {boolean}
   * @memberof FlightBookingProjectionRequest
   */
  test?: boolean;
  /**
   *
   * @type {string}
   * @memberof FlightBookingProjectionRequest
   */
  userId: string;
  /**
   *
   * @type {string}
   * @memberof FlightBookingProjectionRequest
   */
  gondolaBookingId: string;
  /**
   *
   * @type {string}
   * @memberof FlightBookingProjectionRequest
   */
  provider: string;
  /**
   *
   * @type {string}
   * @memberof FlightBookingProjectionRequest
   */
  providerOrderId?: string | null;
  /**
   *
   * @type {string}
   * @memberof FlightBookingProjectionRequest
   */
  bookingStatus: FlightBookingProjectionRequestBookingStatusEnum;
  /**
   * Search-verified issued-ticket document count (canonical tickets or trusted sandbox issuance); supports status display without distributing ticket identifiers. Does not establish monitoring eligibility or full passenger coverage.
   * @type {number}
   * @memberof FlightBookingProjectionRequest
   */
  verifiedTicketCount?: number;
  /**
   *
   * @type {number}
   * @memberof FlightBookingProjectionRequest
   */
  projectionVersion: number;
  /**
   * Optional with itinerary_digest as a pair. Zero identifies the original itinerary. A positive revision requires verified change ingestion.
   * @type {number}
   * @memberof FlightBookingProjectionRequest
   */
  itineraryRevision?: number;
  /**
   * Optional with revision evidence. Explicit true pauses monitoring even at revision zero; explicit false clears temporary attention but never permits monitoring of a positive revision. Omission preserves existing assistance during mixed-producer rollout.
   * @type {boolean}
   * @memberof FlightBookingProjectionRequest
   */
  changeRequiresAssistance?: boolean;
  /**
   * SHA256 of the canonical internal itinerary projection. Recomputed by Parser; binds one immutable itinerary to its revision.
   * @type {string}
   * @memberof FlightBookingProjectionRequest
   */
  itineraryDigest?: string;
  /**
   *
   * @type {string}
   * @memberof FlightBookingProjectionRequest
   */
  confirmationNumber?: string | null;
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof FlightBookingProjectionRequest
   */
  airlineLocators?: { [key: string]: string };
  /**
   *
   * @type {Array<string>}
   * @memberof FlightBookingProjectionRequest
   */
  ticketNumbers: Array<string>;
  /**
   *
   * @type {string}
   * @memberof FlightBookingProjectionRequest
   */
  departureIata: string;
  /**
   *
   * @type {string}
   * @memberof FlightBookingProjectionRequest
   */
  arrivalIata: string;
  /**
   *
   * @type {Date}
   * @memberof FlightBookingProjectionRequest
   */
  departureDatetime: Date;
  /**
   *
   * @type {Date}
   * @memberof FlightBookingProjectionRequest
   */
  arrivalDatetime: Date;
  /**
   *
   * @type {Array<{ [key: string]: any; }>}
   * @memberof FlightBookingProjectionRequest
   */
  passengers: Array<{ [key: string]: any }>;
  /**
   *
   * @type {Array<{ [key: string]: any; }>}
   * @memberof FlightBookingProjectionRequest
   */
  flightSegments: Array<{ [key: string]: any }>;
  /**
   *
   * @type {number}
   * @memberof FlightBookingProjectionRequest
   */
  totalCost?: number | null;
  /**
   *
   * @type {string}
   * @memberof FlightBookingProjectionRequest
   */
  currency?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof FlightBookingProjectionRequest
   */
  isRoundTrip: boolean;
  /**
   *
   * @type {boolean}
   * @memberof FlightBookingProjectionRequest
   */
  cancelled?: boolean;
}

/**
 * @export
 */
export const FlightBookingProjectionRequestBookingStatusEnum = {
  OrderCreated: "order_created",
  TicketingPending: "ticketing_pending",
  PartiallyTicketed: "partially_ticketed",
  Ticketed: "ticketed",
  Failed: "failed",
  NeedsAttention: "needs_attention",
} as const;
export type FlightBookingProjectionRequestBookingStatusEnum =
  (typeof FlightBookingProjectionRequestBookingStatusEnum)[keyof typeof FlightBookingProjectionRequestBookingStatusEnum];

/**
 * Check if a given object implements the FlightBookingProjectionRequest interface.
 */
export function instanceOfFlightBookingProjectionRequest(
  value: object
): value is FlightBookingProjectionRequest {
  if (!("userId" in value) || value["userId"] === undefined) return false;
  if (!("gondolaBookingId" in value) || value["gondolaBookingId"] === undefined)
    return false;
  if (!("provider" in value) || value["provider"] === undefined) return false;
  if (!("bookingStatus" in value) || value["bookingStatus"] === undefined)
    return false;
  if (
    !("projectionVersion" in value) ||
    value["projectionVersion"] === undefined
  )
    return false;
  if (!("ticketNumbers" in value) || value["ticketNumbers"] === undefined)
    return false;
  if (!("departureIata" in value) || value["departureIata"] === undefined)
    return false;
  if (!("arrivalIata" in value) || value["arrivalIata"] === undefined)
    return false;
  if (
    !("departureDatetime" in value) ||
    value["departureDatetime"] === undefined
  )
    return false;
  if (!("arrivalDatetime" in value) || value["arrivalDatetime"] === undefined)
    return false;
  if (!("passengers" in value) || value["passengers"] === undefined)
    return false;
  if (!("flightSegments" in value) || value["flightSegments"] === undefined)
    return false;
  if (!("isRoundTrip" in value) || value["isRoundTrip"] === undefined)
    return false;
  return true;
}

export function FlightBookingProjectionRequestFromJSON(
  json: any
): FlightBookingProjectionRequest {
  return FlightBookingProjectionRequestFromJSONTyped(json, false);
}

export function FlightBookingProjectionRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FlightBookingProjectionRequest {
  if (json == null) {
    return json;
  }
  return {
    test: json["test"] == null ? undefined : json["test"],
    userId: json["user_id"],
    gondolaBookingId: json["gondola_booking_id"],
    provider: json["provider"],
    providerOrderId:
      json["provider_order_id"] == null ? undefined : json["provider_order_id"],
    bookingStatus: json["booking_status"],
    verifiedTicketCount:
      json["verified_ticket_count"] == null
        ? undefined
        : json["verified_ticket_count"],
    projectionVersion: json["projection_version"],
    itineraryRevision:
      json["itinerary_revision"] == null
        ? undefined
        : json["itinerary_revision"],
    changeRequiresAssistance:
      json["change_requires_assistance"] == null
        ? undefined
        : json["change_requires_assistance"],
    itineraryDigest:
      json["itinerary_digest"] == null ? undefined : json["itinerary_digest"],
    confirmationNumber:
      json["confirmation_number"] == null
        ? undefined
        : json["confirmation_number"],
    airlineLocators:
      json["airline_locators"] == null ? undefined : json["airline_locators"],
    ticketNumbers: json["ticket_numbers"],
    departureIata: json["departure_iata"],
    arrivalIata: json["arrival_iata"],
    departureDatetime: new Date(json["departure_datetime"]),
    arrivalDatetime: new Date(json["arrival_datetime"]),
    passengers: json["passengers"],
    flightSegments: json["flight_segments"],
    totalCost: json["total_cost"] == null ? undefined : json["total_cost"],
    currency: json["currency"] == null ? undefined : json["currency"],
    isRoundTrip: json["is_round_trip"],
    cancelled: json["cancelled"] == null ? undefined : json["cancelled"],
  };
}

export function FlightBookingProjectionRequestToJSON(
  json: any
): FlightBookingProjectionRequest {
  return FlightBookingProjectionRequestToJSONTyped(json, false);
}

export function FlightBookingProjectionRequestToJSONTyped(
  value?: FlightBookingProjectionRequest | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    test: value["test"],
    user_id: value["userId"],
    gondola_booking_id: value["gondolaBookingId"],
    provider: value["provider"],
    provider_order_id: value["providerOrderId"],
    booking_status: value["bookingStatus"],
    verified_ticket_count: value["verifiedTicketCount"],
    projection_version: value["projectionVersion"],
    itinerary_revision: value["itineraryRevision"],
    change_requires_assistance: value["changeRequiresAssistance"],
    itinerary_digest: value["itineraryDigest"],
    confirmation_number: value["confirmationNumber"],
    airline_locators: value["airlineLocators"],
    ticket_numbers: value["ticketNumbers"],
    departure_iata: value["departureIata"],
    arrival_iata: value["arrivalIata"],
    departure_datetime: value["departureDatetime"].toISOString(),
    arrival_datetime: value["arrivalDatetime"].toISOString(),
    passengers: value["passengers"],
    flight_segments: value["flightSegments"],
    total_cost: value["totalCost"],
    currency: value["currency"],
    is_round_trip: value["isRoundTrip"],
    cancelled: value["cancelled"],
  };
}
